import { deleteRequest, get, post, postfd, put } from "../helpers/apihelpers";

export const CreateClientChatService=async(data)=>{
    try {
        const result = await post(`api/customer/sendMessageToCustomer`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreateClientSessionChatService=async(data)=>{
    try {
        const result = await post(`api/customer/sendSessionMessageToCustomer`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreateClientAttachmentService=async(data)=>{
    try {
        const result = await postfd(`api/customer/sendAttachmentToCustomer`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const CreateClientAttachmentSessionService=async(data)=>{
    try {
        const result = await postfd(`api/customer/sendAttachmentToCustomerSession`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreateClientTemplateService=async(data)=>{
    try {
        const result = await post(`api/customer/sendWatiTemplateMessage`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const SendClientTemplateMessageMassService=async(data)=>{
    try {
        const result = await post(`api/customer/sendWatiTemplateMessageMass`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}




export const GetClientChatService=async(id,page,text,from_date,to_date)=>{
    try {
        const result = await get(`api/customer/getMessageToCustomer/${id}?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}
